import { useTransition, config } from "@react-spring/web";
export const useTransitionFactory = (item: string | Record<string, any> | undefined) =>
    useTransition(item, {
        from: { opacity: 0 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
        delay: 200,
        config: config.molasses
    });
